// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"fd524390","421":"d222a8a4","511":"f211c303","679":"f78bef6e","707":"ce5568a8","767":"2d9ccf98","851":"2bd44638","873":"98002c54","942":"a65b4349"}[chunkId] + ".chunk.js";
};